import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import api from '../api/client';
import { Search, Loader2 } from 'lucide-react';

const SearchPage = () => {
  const [params] = useSearchParams();
  const q = params.get('q') || '';
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get('/products', { params: { search: q } })
      .then(res => setResults(res.data))
      .catch(() => setResults([]))
      .finally(() => setLoading(false));
  }, [q]);

  return (
    <div className="max-w-[1400px] mx-auto px-4 py-6">
      <div className="flex items-center gap-2 mb-6">
        <Search className="w-5 h-5 text-[#F46A25]" />
        <h1 className="text-2xl md:text-3xl font-black text-[#12263A]">Search results for “{q}”</h1>
      </div>
      <p className="text-sm text-neutral-600 mb-6">{results.length} products found</p>

      {loading ? (
        <div className="flex justify-center py-16"><Loader2 className="w-8 h-8 animate-spin text-[#F46A25]" /></div>
      ) : results.length === 0 ? (
        <div className="bg-white border border-neutral-200 rounded-sm p-10 text-center">
          <p className="text-neutral-600 mb-4">No products found. Try a different search.</p>
          <Link to="/" className="inline-block bg-[#F46A25] text-white font-bold px-6 py-2 rounded-sm hover:bg-[#e05a15]">Back to home</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
          {results.map(p => <ProductCard key={`${p.id}-${p.variant_id || 'base'}`} product={p} />)}
        </div>
      )}
    </div>
  );
};

export default SearchPage;
